import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { ContentModel } from "@tecumseh/Services/PIMExportHistoryService";
import { Draft } from "immer";

export type CustomPIMExportResultType = {
    exportList: ContentModel[];
};
const initialState: CustomPIMExportResultType = {
    exportList: [],
};

const reducer = {
    "Custom/PIMExport/SetContents": (draft: Draft<CustomPIMExportResultType>, action: { contentResults: any }) => {
        draft.exportList = action.contentResults;

    },
};
export default createTypedReducerWithImmer(initialState, reducer);
